<template>
    <main class="w-full md:grow h-full flex justify-center gap-10 min-w-0">
        <div class="
            flex flex-row w-full md:w-fit md:border md:border-white-foreground/10
            md:shadow-sm md:rounded-t-3xl"
            :class="{
                'ml-auto': $slots.aside
            }"
        >
            <slot />
        </div>

        <slot name="aside" />
    </main>
</template>
